var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompletedCheckboxIcon = function SvgCompletedCheckboxIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#19AF00",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M12.55 5.669A5.833 5.833 0 1 1 9.748 1.78M5.082 6.25l1.75 1.75 5.834-5.833"
  })));
};
export { SvgCompletedCheckboxIcon as ReactComponent };
export default __webpack_public_path__ + "70e8e7bbb9c808492a638c61625607e9.svg";